import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useOnboarding } from "../contexts/OnboardingContext";
import ConversationPanal from "../../../assets/Conversation-panal.svg";
import "./Onboarding-1.css";
import api from "../../../axiosconfig";

export const Onboarding1 = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { onboardingData, setOnboardingData } = useOnboarding();
  const authUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    const emailParam = searchParams.get("email");
    const targetEmail = (
      emailParam ||
      authUser?.email ||
      authUser?.sub ||
      ""
    )
      .trim()
      .toLowerCase();
    if (targetEmail && targetEmail !== onboardingData.email) {
      setOnboardingData((prev) => ({ ...prev, email: targetEmail }));
    }
  }, [searchParams, authUser, onboardingData.email, setOnboardingData]);

  const handleContinue = () => {
    navigate("/Onboarding-Header");
  };

  const handleSkip = async () => {
    const email = (
      onboardingData.email ||
      authUser?.email ||
      authUser?.sub ||
      ""
    )
      .trim()
      .toLowerCase();

    if (email) {
      try {
        await api.post("/register", {
          request: "profileData",
          email,
          name: " ",
          age: null,
          gender: null,
          focus: null,
        });
      } catch (err) {
        console.error("Error setting null profile on Onboarding-1 skip:", err);
      }
    }
    navigate("/Onboarding-Header4");
  };

  return (
    <div className="onboarding1-page-wrapper">
      {/* Top Navigation / Glassmorphic Back button */}
      <button
        type="button"
        className="onboarding1-back-btn"
        onClick={() => navigate(-1)}
        aria-label="Go Back"
      >
        <span className="onboarding1-back-arrow" aria-hidden="true">
          &larr;
        </span>
        <span className="onboarding1-back-label">Back</span>
      </button>

      {/* 1. TOP HEADER (Headline & Subtitle) */}
      <div className="onboarding1-header-section">
        <h1 className="onboarding1-title">
          Let&rsquo;s personalize Mindsherpa for you
        </h1>
        <p className="onboarding1-subtitle">
          Your individual data will not be shared outside of Mindsherpa
        </p>
      </div>

      {/* 2. MIDDLE ILLUSTRATION (Centered) */}
      <div className="onboarding1-illustration-container">
        <img
          src={ConversationPanal}
          alt="Personalization conversation"
          className="onboarding1-illustration"
        />
      </div>

      {/* 3. BOTTOM BUTTONS (Stacked & Responsively Centered) */}
      <div className="onboarding1-actions-container">
        <button
          type="button"
          className="onboarding1-primary-btn"
          onClick={handleContinue}
        >
          Continue
        </button>
        <button
          type="button"
          className="onboarding1-secondary-btn"
          onClick={handleSkip}
        >
          Remind me later
        </button>
      </div>
    </div>
  );
};

export default Onboarding1;
